import { createSelector } from "reselect";
import { AppState } from "../types";

/** If a script has this category id, it's a utility script. */
export const UTILITY_SCRIPT_CATEGORY_ID = 16074;

/** If a script has this category id, it's a competition metric. */
export const COMPETITION_METRIC_CATEGORY_ID = 16671;

export const getTags = (state: AppState) => state.notebook.tags;

const getCategoryIds = createSelector(
  [getTags],
  tags => tags?.map(tag => tag.id) || []
);

/** Selects whether category information has been hydrated. */
export const getCategoriesEnabled = createSelector(
  [getCategoryIds],
  categoryIds => categoryIds !== null
);

/** Selects whether the current script is a utility script. */
export const getIsUtilityScript = createSelector(
  [getCategoryIds],
  categoryIds =>
    categoryIds ? categoryIds.includes(UTILITY_SCRIPT_CATEGORY_ID) : false
);

/** Selects whether the current script is a competition metric. */
export const getIsCompetitionMetric = createSelector(
  [getCategoryIds],
  categoryIds =>
    categoryIds ? categoryIds.includes(COMPETITION_METRIC_CATEGORY_ID) : false
);
